module.exports = "fieldset label {\n  display: block;\n}\n\nlabel input[type='radio'] {\n  margin: 4px 5px;\n}\n"